import { HTMLInputTypeAttribute } from "react";
import { twMerge } from "tailwind-merge";

type InputProps = {
  type: HTMLInputTypeAttribute;
  placeholder: string;
  className?: string;
  required?: boolean;
  disabled?: boolean;
  onChange?: (event: any) => void;
  onBlur?: (event: any) => void;
  value?: string;
};

const Input = ({
  type,
  placeholder,
  className,
  disabled,
  onChange,
  onBlur,
  value,
}: InputProps) => {
  return (
    <div className="relative">
      <input
        type={type}
        className={twMerge(
          "block w-full px-3 py-2 bg-white border border-slate-300 rounded-md text-base shadow-sm placeholder-slate-400 focus:outline-none focus:border-sky-500 focus:ring-1 focus:ring-sky-500 disabled:bg-slate-50 disabled:text-slate-500 disabled:border-slate-200 disabled:shadow-none focus:invalid:border-primary focus:invalid:ring-primary",
          className,
          disabled
            ? "bg-slate-50 text-slate-500 border-slate-200 shadow-none cursor-not-allowed"
            : ""
        )}
        placeholder={placeholder}
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      />
    </div>
  );
};

export default Input;
